import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    OnInit,
    SecurityContext
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LgvModel } from '../../../../data-models/longevity.model';
import { FormControl } from '@angular/forms';
import {
    LgvClientService,
    LgvUserService,
    NotificationService
} from '../../../../core/core.module';
import { BehaviorSubject, filter, Subject, takeUntil } from 'rxjs';
import { LgvAuthMgrService } from '../../../../core/services/lgv-auth-mgr.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'lgv-contact-agent-dialog',
    templateUrl: './contact-agent-dialog.component.html',
    styleUrls: ['./contact-agent-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactAgentDialogComponent implements OnInit {
    opportunity: LgvModel.Opportunity;
    message = '';
    agentNameDisplay$ = new BehaviorSubject(null);
    onDestroy$ = new Subject();
    constructor(
        public dialogRef: MatDialogRef<ContactAgentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private lgvUserSvc: LgvUserService,
        private lgvAuthMgr: LgvAuthMgrService,
        private notificationSvc: NotificationService,
        private lgvClientSvc: LgvClientService,
        private sanitizer: DomSanitizer
    ) {
        this.opportunity = data?.opportunity;
    }

    ngOnInit(): void {
        this.lgvUserSvc.AgentDTO$.pipe(
            filter(f => !!f),
            takeUntil(this.onDestroy$)
        ).subscribe(x => {
            this.agentNameDisplay$.next(
                `${x.agentInfo?.firstName} ${x.agentInfo?.lastName}`
            );
        });
    }

    ngOnDestroy() {
        this.onDestroy$.next(false);
        this.onDestroy$.complete();
    }

    onSendEmail() {
        if (!this.lgvAuthMgr.IsClient) {
            this.notificationSvc.warn(
                'Messages are not sent for Client Impersonation'
            );
            return;
        }

        let cleanMsg = this.sanitizer.sanitize(
            SecurityContext.HTML,
            this.message
        );

        cleanMsg += `<br><p>Linked Quote:</p>

        <table>
            <tr>
                <td style="width: 200px;"><strong>Rate / APR</strong></td>
                <td>${this.opportunity?.opportunityInfo?.matchedRate} | ${this.opportunity?.opportunityInfo?.matchedApr}</td>
            </tr>
            <tr>
                <td style="width: 200px;"><strong>Points / Price</strong></td>
                <td>${this.opportunity?.opportunityInfo?.points} | ${this.opportunity?.opportunityInfo?.matchedPrice}</td>
            </tr>
            <tr>
                <td style="width: 200px;"><strong>Points Cost</strong></td>
                <td>${this.opportunity?.opportunityInfo?.pointsCost}</td>
            </tr>
            <tr>
                <td style="width: 200px;"><strong>Monthly P&I</strong></td>
                <td>${this.opportunity?.opportunityInfo?.points}</td>
            </tr>
            <tr>
                <td style="width: 200px;"><strong>Mortgage Interest</strong></td>
                <td>${this.opportunity?.opportunityInfo?.marketMonthlyPaymentMi}</td>
            </tr>
            <tr>
                <td style="width: 200px;"><strong>Lock Period (Days)</strong></td>
                <td>${this.opportunity?.opportunityInfo?.lockPeriod}</td>
            </tr>
            <tr>
                <td style="width: 200px;"><strong>Loan Amount</strong></td>
                <td>${this.opportunity?.opportunityInfo?.loanAmount}</td>
            </tr>
        </table>`;

        this.lgvClientSvc
            .PostClientMessageForType(this.data.type, cleanMsg)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(
                x => {
                    if (x === null) {
                        this.notificationSvc.success('You message was sent.');
                        this.dialogRef.close();
                    }
                },
                err =>
                    this.notificationSvc.success(
                        'There was an error submitting your message.'
                    )
            );
    }
}
